import React, { useCallback, useContext, useState } from "react";
import * as Sentry from "@sentry/react";
import { RootStoreContext } from "src/stores/RootStore";
import { observer } from "mobx-react";
import { UI } from "@wwimmo/ui";
import { Route, selectRoute } from "src/config/routes";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { getTime } from "src/utils/Date";
import styles from "./CloseLiveMode.module.css";

const CloseLiveModeBase = observer(() => {
    const { assemblyStore, authStore } = useContext(RootStoreContext);
    const { t } = useTranslation();
    const history = useHistory();

    const [isClosingAssembly, setIsClosingAssembly] = useState<boolean>(false);

    const onClickStopLiveMode = useCallback(async () => {
        setIsClosingAssembly(true);

        let isAssemblyClosed: boolean;

        try {
            isAssemblyClosed = await assemblyStore.recordClosingTimeAndCloseLiveMode(
                getTime(new Date().toISOString())
            );
        } finally {
            setIsClosingAssembly(false);
        }

        if (!isAssemblyClosed) {
            return;
        }

        history.push(
            selectRoute(Route.assemblyDetails, authStore.user?.role, {
                assemblyid: assemblyStore.currentAssembly?.id || ""
            })
        );
    }, [assemblyStore, authStore.user?.role, history]);

    return (
        <UI.Card title={t("screens.assemblies.livemode.title").toString()}>
            <div className={styles.CardContent}>
                <div className={styles.DivIconCheck}>
                    <UI.Icon icon={UI.SVGIcon.Check} className={styles.IconCheck} size={45} />
                </div>

                <div className={styles.Title}>{t("screens.assemblies.livemode.close")}</div>
                <div className={styles.Text}>{t("screens.assemblies.livemode.close_text")}</div>
                <UI.Button
                    className={styles.ButtonStopLiveMode}
                    label={t("screens.assemblies.livemode.close_button")}
                    onClick={onClickStopLiveMode}
                    variant="danger"
                    disabled={isClosingAssembly}
                />
            </div>
        </UI.Card>
    );
});

export const CloseLiveMode = Sentry.withProfiler(CloseLiveModeBase);
